
<footer class="w-full pt-6">
    <div class="w-8/12 mx-auto py-6 ">
        <div class="grid md:grid-cols-12 justify-center ">
            <div class="col-span-2 text-center">
                <div class="text-center">
                    <img src="assets/image/footer-imgs/img.png" alt="Logo" class="w-3/4 mx-3">
                    <img src="assets/image/footer-imgs/black-logo.webp" alt="Logo" class="w-3/4 mx-3">
                </div>
            </div>
            <div class="col-span-4">
                <h5 class="font-bold text-[18px] text-gray-700 uppercase">Quick Contact</h5>
                <ul class="list-unstyled py-2 text-[15px]">
                    <li class="py-1">WZ-6, Jail Rd, <br>Lajwanti Garden,Mayapuri<br> New Delhi,Delhi - 110046</li>
                    <li class="py-3">
                        <a href="tel:18008890845" class="primary-color">
                            <i class="fas fa-phone-alt"></i> 18008890845
                        </a>
                    </li>
                    <li class="py-1">
                        <a href="mailto:info@paiu.in" class="primary-color">
                            <i class="fas fa-envelope"></i> info@paiu.in
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-span-2">
                <h5 class="font-bold text-[18px] text-gray-700 uppercase">Our Programs</h5>
                <ul class="list-unstyled py-2 text-[15px]">
                    <li class="py-1"><a href="" class="">Bachelor’s</a></li>
                    <li class="py-1"><a href="" class="">Master’s</a></li>
                    <li class="py-1"><a href="" class="">DBA</a></li>
                    <li class="py-1"><a href="" class="">Ph.D</a></li>
                </ul>
            </div>
            <div class="col-span-2">
                <h5 class="font-bold text-[18px] text-gray-700 uppercase">Our Stories</h5>
                <ul class="list-unstyled py-2 text-[15px]">
                    <li class="py-1"><a href="" class="">Blogs</a></li>
                    <li class="py-1"><a href="" class="">FAQ</a></li>
                    <li class="py-1"><a href="" class="">Contact Us</a></li>
<!--                    <li class="py-1"><a href="" class="">Apply Now</a></li>-->
                </ul>
            </div>
            <div class="col-span-2">
                <h5 class="font-bold text-[18px] text-gray-700 uppercase">Quick Links</h5>
                <ul class="list-unstyled py-2 text-[15px]">
                    <li class="py-1"><a href="" class="">Home</a></li>
                    <li class="py-1"><a href="" class="">About Us</a></li>
                    <li class="py-1"><a href="" class="">Recognitions</a></li>
                    <li class="py-1"><a href="" class="">Affiliates and
                        Partners</a></li>
                </ul>
            </div>
        </div>
        <div class="flex justify-end ">
            <div class="w-1/3">
                <div class="hs_email hs-fieldtype-text field hs-form-field">
                    <label for="email" class="form-label text-[#ff7a59] text-[12px] font-semibold">Newsletter <span
                        class="text-danger">*</span></label>
                    <div class="input ">
                        <input type="email" id="email" class="form-control bg-gray-200 w-full p-3 outline-0"
                               placeholder="Enter your email" required>
                    </div>
                </div>
                <div class="text-start mt-3">
                    <button
                        class="btn bg-[#ff7a59] px-3 py-2 font-semibold text-[14px] rounded text-white fw-bold text-md"
                        id="submitButton" type="submit">Subscribe
                    </button>
                </div>
            </div>
        </div>
    </div>
    <hr/>
    <div class="w-8/12 mx-auto text-gray-800">
        <div class="w-1/2 py-4 justify-around mx-auto text-4xl text-gray-600 flex justify-content-center">
            <i class="fa-brands fa-facebook-f"></i>
            <i class="fab fa-instagram fs-1"></i>
            <i class="fab fa-linkedin fs-1"></i>
            <i class="fab fa-twitter fs-1"></i>
            <i class="fab fa-pinterest fs-1"></i>
            <i class="fab fa-youtube fs-1"></i>
        </div>
    </div>
    <div class="text-center text-gray-500 bg-gray-100 py-5">
        <small>&copy; 2025 PAI University. All Rights Reserved.</small>
    </div>
</footer>
